import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { exchangeFeesAPI } from '../../config/api';

const ExchangeSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { feePaymentId } = useParams();
  const [searchParams] = useSearchParams();

  const [status, setStatus] = useState('processing');
  const [confirmationAttempted, setConfirmationAttempted] = useState(false);

  useEffect(() => {
    // منع الاستدعاء المتكرر
    if (confirmationAttempted) return;

    const confirm = async () => {
      try {
        setConfirmationAttempted(true);
        const paymentId = searchParams.get('id') || searchParams.get('payment_id');
        if (!paymentId) {
          setStatus('failed');
          return;
        }
        
        // إضافة تأخير قصير لضمان عدم الإرسال المضاعف
        await new Promise(resolve => setTimeout(resolve, 500));
        
        await exchangeFeesAPI.confirmPayment({
          paymentId: feePaymentId,
          moyasarPaymentId: paymentId,
          moyasarData: { id: paymentId }
        });
        setStatus('success');
        setTimeout(() => navigate('/lab/exchange-offers'), 1200);
      } catch (e) {
        console.error('Payment confirmation error:', e);
        setStatus('failed');
      }
    };
    
    // تأخير إضافي قبل بدء العملية
    const timer = setTimeout(confirm, 200);
    return () => clearTimeout(timer);
  }, [feePaymentId, navigate, searchParams, confirmationAttempted]);

  return (
    <div className="container mx-auto px-4 py-12 text-center">
      {status === 'success' && (
        <>
          <h2 className="text-2xl font-semibold text-green-600 mb-2">{t('exchangeSuccess.paymentSuccessful')}</h2>
          <p className="text-gray-600">{t('exchangeSuccess.redirectMessage')}</p>
        </>
      )}
      {status === 'processing' && (
        <>
          <h2 className="text-2xl font-semibold text-blue-600 mb-2">{t('exchangeSuccess.confirmingPayment')}</h2>
          <p className="text-gray-600">{t('exchangeSuccess.verifyingPayment')}</p>
        </>
      )}
      {status === 'failed' && (
        <>
          <h2 className="text-2xl font-semibold text-red-600 mb-2">{t('exchangeSuccess.paymentFailed')}</h2>
          <p className="text-gray-600">{t('exchangeSuccess.confirmFailMessage')}</p>
        </>
      )}
      <div className="mt-6">
        <button
          onClick={() => navigate('/lab/exchange-offers')}
          className="px-6 py-2 rounded-md bg-green-600 text-white hover:bg-green-700"
        >
          {t('exchangeSuccess.returnNow')}
        </button>
      </div>
    </div>
  );
};

export default ExchangeSuccess;


